<template>
  <div class="page">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('menu.protocol')">
          <el-select v-model="searchParams.protocolId" :placeholder="$t('public.text5')" @change="onChange">
            <el-option v-for="item in protocolList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('menu.errCode')">
          <el-select v-model="searchParams.errorCode" :placeholder="$t('public.text5')">
            <el-option v-for="item in errorList" :key="item.errorCode" :label="item.errorCode" :value="item.errorCode"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text7')">
          <el-input clearable v-model="searchParams.bikeCode" :placeholder="$t('public.text1')"/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text45')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 8px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <div class="searchSubmit">
          <DiluButton type="search" @click="search"/>
          <DiluButton type="reset" @click="reset"/>
        </div>
      </el-form>
    </div>
    <DiluTable :list="tableData" :tableConfig="tableConfig" :total="total" :pageSize="searchParams.pageSize" @currentChange="currentChange">
      <el-table-column prop="id" label="ID" width="100" align="left"/>
      <el-table-column prop="bikeCode" :label="$t('pages.equipment.text7')" width="150" align="left"/>
      <el-table-column prop="errorCode" :label="$t('menu.errCode')" width="120" align="left"/>
      <el-table-column prop="hwType" :label="$t('pages.equipment.text339')" width="180" align="lefft">
        <template slot-scope="scope">
          <span v-if="scope.row.hwType==10">{{$t("pages.equipment.text178") }}</span>
          <span v-if="scope.row.hwType==15">{{$t("pages.equipment.text202") }}</span>
          <span v-if="scope.row.hwType==20">{{$t("pages.equipment.text203") }}</span>
          <span v-if="scope.row.hwType==25">{{$t("pages.equipment.text204") }}</span>
          <span v-if="scope.row.hwType==30">{{$t("pages.equipment.text205") }}</span>
          <span v-if="scope.row.hwType==35">{{$t("pages.equipment.text206") }}</span>
          <span v-if="scope.row.hwType==40">{{$t("pages.equipment.text207") }}</span>
          <span v-if="scope.row.hwType==45">{{$t("pages.equipment.text208") }}</span>
          <span v-if="scope.row.hwType==50">{{$t("pages.equipment.text347") }}</span>
          <span v-if="scope.row.hwType==55">{{$t("pages.equipment.text348") }}</span>
          <span v-if="scope.row.hwType==60">{{$t("pages.equipment.text349") }}</span>
          <span v-if="scope.row.hwType==65">{{$t("pages.equipment.text350") }}</span>
          <span v-if="scope.row.hwType==70">{{$t("pages.equipment.text362") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="errorName" :label="$t('pages.equipment.text355')" width="250" align="left"/>
      <el-table-column prop="createdAt" :label="$t('afterSales.text36')" width="150" align="left"/>
      <el-table-column prop="address" :label="$t('public.text4')" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="bikeDetail(scope.row)" type="text">{{ $t("afterSales.text37") }}</el-button>
            <el-button @click="faultDetail(scope.row)" type="text">{{ $t("pages.equipment.text363") }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

     <!-- 故障详情 -->
    <ViewError @dialogClose="dialogClose" :errorVisible="errorVisible" :errorRecord="errorRecord"/>

  </div>
</template>

<script>
import { mapState } from "vuex";
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import ViewError from "./module/viewError"; 
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        //选中的开始日期前的时间禁选
        disabledDate: (time) => {
          return time.getTime() < this.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      errorRecord: {},
      errorVisible: false,
      protocolList: [],
      errorList: [],
      searchParams: {
        protocolId: null, 
        errorCode: null, 
        bikeCode: null, 
        startAt: null,
        stopAt: null,
        language: null,
        pageNum: 1, 
        pageSize: 10, 
      }, // 搜索条件
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      total: 0,
      isSerch: false, 
      hyberHtml: null,
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    DiluTable,
    DiluButton,
    ViewError
  },
  mounted() {
    this.setLanguage();
    this.loadProtocol();
  },
  methods: {
    dialogClose() {
      this.errorVisible = false;
    },
    setLanguage() {
      this.searchParams.language = 'en';
      let platformData = JSON.parse(localStorage.getItem('platformData'));
      if (platformData) {
          if (platformData.region == 'cn') {
              this.searchParams.language = 'zh';
          } else if (platformData.region == 'jp') {
              this.searchParams.language = 'ja';
          }
      }
    },
    onChange() {
      if (this.searchParams.protocolId!=null&&this.searchParams.protocolId!='') {
        this.loadError();
      }
    },
    loadError() {
      this.request.codeList({'protocolId':this.searchParams.protocolId}).then((res) => {
        this.errorList = res.data;
      });
    },
    loadProtocol() {
      const that=this;
      that.request.protocolList({}).then((res) => {
        that.protocolList = res.data;
        if (that.protocolList.length>0) {
          that.searchParams.protocolId=that.protocolList[0].id;
        }
      });
    },
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.faultList();
    },
    //重置
    reset() {
      this.isSerch = false; 
      this.searchParams.pageNum = 1;
      this.searchParams.pageSize = 10;
      this.searchParams.protocolId = null;
      this.searchParams.errorCode = null;
      this.searchParams.bikeCode = null;
      this.searchParams.startAt = null;
      this.searchParams.stopAt = null;
      this.total = 0;
      this.faultList();
    },
    //车辆详情
    bikeDetail(e) {
      this.$router.push({
        path: "/equipment/deviceManagement/equipmentInfo",
        query: {
          id: e.bikeId,
          bikeCode: e.bikeCode,
        },
      });
    },
    //故障详情
    faultDetail(e) {
      this.errorRecord=e;
      this.errorRecord.lang=this.searchParams.language;
      this.errorVisible=true;
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams.pageNum = 1;
        this.searchParams.pageSize = 10;
      }
      this.searchParams.pageNum = e;
      this.faultList();
    },
    //查询列表
    faultList() {
      this.request.faultBikeList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.search {
  margin-bottom: 20px;
}
</style>